import { useAtomValue } from 'jotai'
import React from 'react'

import { surveyGroupIdAtom } from '../../atoms'

export const useMainQueryKey = () => {
  const surveyGroupId = useAtomValue(surveyGroupIdAtom)

  return React.useMemo(
    () => ['SurveyGroupFilterInformation_Main', { surveyGroupId }],
    [surveyGroupId],
  )
}
